import React from 'react';

import { LinkList } from '@eika/link-list';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';
import { settingsTrackIDs } from '../../../utils/gtm/trackIDs/settings';

const MeMyselfAndI: React.FC = () => {
    const translated = useTranslation();
    const { minBoligLink, becomeCustomerChildLink, featureToggles } = useConfig();

    return (
        <>
            {(!featureToggles.disableMyHouse || featureToggles.enableBecomeCustomerChild) && (
                <>
                    <h3 className="settings__title">{translated.settings.meMyselfAndI}</h3>
                    <LinkList className="settings__link-list">
                        {!featureToggles.disableMyHouse && minBoligLink?.url && (
                            <LinkList.Item
                                href={minBoligLink.url}
                                data-track-id={settingsTrackIDs.link}
                                data-track-linkname={translated.settings.minBolig}
                            >
                                {translated.settings.minBolig}
                            </LinkList.Item>
                        )}
                        {featureToggles.enableBecomeCustomerChild && becomeCustomerChildLink?.url && (
                            <LinkList.Item
                                href={becomeCustomerChildLink.url}
                                data-track-id={settingsTrackIDs.link}
                                data-track-linkname={translated.settings.becomeCustomerChild}
                            >
                                {translated.settings.becomeCustomerChild}
                            </LinkList.Item>
                        )}
                    </LinkList>
                </>
            )}
        </>
    );
};

export default MeMyselfAndI;
